/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Build environment variables injected via the `define` block in vite.config.mts.
 * Vite replaces these identifiers with literal values at build time.
 */
declare const _BUILD_PACKAGE_VERSION: string;
declare const _BUILD_API_URL: string;
declare const _BUILD_STAGING: boolean;
declare const _BUILD_DEVELOPMENT: boolean;
declare const _BUILD_PRODUCTION: boolean;

function getApiUrl(): string {
   if (_BUILD_API_URL && _BUILD_API_URL !== '') {
      return _BUILD_API_URL;
   } else {
      const origin_url = new URL(globalThis.location.origin);

      // Setup default for development
      if (origin_url.hostname.includes('localhost')) {
         return 'http://localhost:9081';
      } else if (origin_url.hostname.startsWith('app.')) {
         // app.example.com → api.example.com
         return origin_url.origin.replace('app.', 'api.');
      }
      // Otherwise add -api to the first hostname part (foo.example.com → foo-api.example.com)
      else {
         const hostname_parts = origin_url.hostname.split('.');
         hostname_parts[0] = `${hostname_parts[0]}-api`;
         return `https://${hostname_parts.join('.')}`;
      }
   }
}

export function isDev() {
   return __APP_ENV__.DEVELOPMENT;
}

/** Returns true when running inside the mobile app entry. */
export function isMobileApp(): boolean {
   return __APP_ENV__.IS_MOBILE_APP;
}

/** Mark the current app instance as the mobile app. Call once from mobileapp_main.ts. */
export function setMobileAppMode(): void {
   __APP_ENV__.IS_MOBILE_APP = true;
}

/** Environment from "define" in vite build. */
export const __APP_ENV__ = {
   PACKAGE_VERSION: _BUILD_PACKAGE_VERSION,
   API_URL: getApiUrl(),
   WS_URL: getApiUrl().replace(/^http/, 'ws'),
   STAGING: _BUILD_STAGING,
   DEVELOPMENT: _BUILD_DEVELOPMENT,
   PRODUCTION: _BUILD_PRODUCTION,
   IS_MOBILE_APP: false,
};
